var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackendDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#939598;}\r\n\t.st1{fill:#808285;}\r\n\t.st2{fill:#58595B;}\r\n\t.st3{fill:#414042;}\r\n\t.st4{fill:#B2B0AD;}\r\n\t.st5{fill:#478CF7;}\r\n\t.st6{fill:#5E9CF7;}\r\n\t.st7{fill:#377DE2;}\r\n\t.st8{fill:#2266D3;}\r\n\t.st9{fill:#FFC91D;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{fill:#A54AF4;}\r\n\t.st12{fill:#893ADD;}\r\n\t.st13{fill:#6C2BC1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,25.2h7.4v4.2h-7.4V25.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,25.2v2.9c0,0.4-0.3,0.7-0.7,0.7h-6.1v0.7h7.4v-4.2H19.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.1,32h13.8c0.5,0,0.8-0.5,0.6-0.9L23,30.1c-0.2-0.4-0.7-0.7-1.2-0.7H10.2c-0.5,0-0.9,0.3-1.2,0.7 l-0.5,0.9C8.3,31.5,8.6,32,9.1,32L9.1,32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.5,31.1L23,30.1c-0.1-0.3-0.4-0.5-0.6-0.6l0.4,0.9c0.2,0.4-0.1,0.9-0.6,0.9H8.5c0,0.3,0.3,0.7,0.7,0.7 h13.8C23.4,32,23.7,31.5,23.5,31.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,25.2H30c0.7,0,1.3-0.6,1.3-1.3V4.8c0-0.7-0.6-1.3-1.3-1.3H2C1.3,3.5,0.7,4,0.7,4.8v19.2 C0.7,24.6,1.3,25.2,2,25.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.5,3.6c0.1,0.2,0.1,0.3,0.1,0.5v19.2c0,0.7-0.6,1.3-1.3,1.3H1.4c-0.2,0-0.4,0-0.5-0.1 C1,24.9,1.5,25.2,2,25.2H30c0.7,0,1.3-0.6,1.3-1.3V4.8C31.3,4.2,31,3.8,30.5,3.6L30.5,3.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.3,24h-2.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.5c0.3,0,0.5,0.2,0.5,0.5S17.6,24,17.3,24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2.5,21.7h27c0.4,0,0.7-0.3,0.7-0.7V5.3c0-0.4-0.3-0.7-0.7-0.7h-27C2.1,4.7,1.8,5,1.8,5.3V21 C1.8,21.4,2.1,21.7,2.5,21.7L2.5,21.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2.6,17.4c-0.1,0-0.3-0.1-0.3-0.3V9.5c0-0.1,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v7.6 C2.9,17.3,2.8,17.4,2.6,17.4z M2.6,8.8c-0.1,0-0.3-0.1-0.3-0.3V8.4c0-0.1,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v0.1 C2.9,8.6,2.8,8.8,2.6,8.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.5,4.7h-0.7v15c0,0.4-0.3,0.7-0.7,0.7H1.8V21c0,0.4,0.3,0.7,0.7,0.7h27c0.4,0,0.7-0.3,0.7-0.7V5.3 C30.2,5,29.9,4.7,29.5,4.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M29.5,4.7v15.7c0,0.4-0.3,0.7-0.7,0.7h-27c0,0.4,0.3,0.7,0.7,0.7h27c0.4,0,0.7-0.3,0.7-0.7V5.3 C30.2,5,29.9,4.7,29.5,4.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.8,14.3H9.7c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h12.1c0.1,0,0.3,0.1,0.3,0.3S21.9,14.3,21.8,14.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.3,14.3H4.7c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h3.5c0.1,0,0.3,0.1,0.3,0.3S8.4,14.3,8.3,14.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M27.3,15.9h-3.7c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h3.7c0.1,0,0.3,0.1,0.3,0.3 C27.5,15.8,27.4,15.9,27.3,15.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.4,15.9H5.9c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h16.5c0.1,0,0.3,0.1,0.3,0.3 C22.7,15.8,22.5,15.9,22.4,15.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M27.3,17.6h-17c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h17c0.1,0,0.3,0.1,0.3,0.3 C27.5,17.5,27.4,17.6,27.3,17.6L27.3,17.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M8.9,17.6H5.9c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h2.9c0.1,0,0.3,0.1,0.3,0.3 C9.1,17.5,9,17.6,8.9,17.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M21.8,19.3H8.9c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h12.9c0.1,0,0.3,0.1,0.3,0.3 C22.1,19.2,21.9,19.3,21.8,19.3L21.8,19.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.9,19.3H4.7c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h3.2c0.1,0,0.3,0.1,0.3,0.3 C8.2,19.2,8,19.3,7.9,19.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M7.6,10.8c0,0-0.1,0-0.1,0L4.6,9.3C4.5,9.2,4.5,9.1,4.5,9c0-0.1,0.1-0.2,0.1-0.2l2.9-1.5 c0.1-0.1,0.3,0,0.4,0.1c0.1,0.1,0,0.3-0.1,0.4L5.3,9l2.5,1.3c0.1,0.1,0.2,0.2,0.1,0.4C7.8,10.8,7.7,10.8,7.6,10.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M11,10.8c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1,0-0.3,0.1-0.4L13.3,9l-2.5-1.3c-0.1-0.1-0.2-0.2-0.1-0.4 c0.1-0.1,0.2-0.2,0.4-0.1L14,8.8c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.1,0.2l-2.9,1.5C11.1,10.8,11,10.8,11,10.8L11,10.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M8.4,11.7C8.3,11.7,8.3,11.7,8.4,11.7c-0.2-0.1-0.3-0.2-0.2-0.4L10,6.6c0.1-0.1,0.2-0.2,0.3-0.2 c0.1,0.1,0.2,0.2,0.2,0.3l-1.8,4.8C8.6,11.6,8.5,11.7,8.4,11.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M22.1,8.9c-2.9,0-5.2-0.7-5.2-1.6v2.9c0,0.9,2.3,1.6,5.2,1.6c2.9,0,5.2-0.7,5.2-1.6c0,0,0-2.2,0-2.9 C27.3,8.2,25,8.9,22.1,8.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M26.8,8v1.7c0,0.9-2.3,1.6-5.2,1.6c-2,0-3.8-0.4-4.6-0.9c0.3,0.8,2.5,1.4,5.1,1.4c2.9,0,5.2-0.7,5.2-1.6 c0,0,0-2.2,0-2.9C27.3,7.6,27.1,7.8,26.8,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 18.5,
    cy: 9.7,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 20.2,
    cy: 10.2,
    r: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M22.1,6c-2.9,0-5.2-0.7-5.2-1.6v2.9c0,0.9,2.3,1.6,5.2,1.6c2.9,0,5.2-0.7,5.2-1.6c0,0,0-2.1,0-2.9 C27.3,5.3,25,6,22.1,6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M26.8,5.1v1.7c0,0.9-2.3,1.6-5.2,1.6c-2,0-3.8-0.4-4.6-0.9c0.3,0.8,2.5,1.4,5.1,1.4c2.9,0,5.2-0.7,5.2-1.6 c0,0,0-2.1,0-2.9C27.3,4.7,27.1,4.9,26.8,5.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 18.5,
    cy: 6.9,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 20.2,
    cy: 7.3,
    r: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M22.1,3.2c-2.9,0-5.2-0.7-5.2-1.6v2.9c0,0.9,2.3,1.6,5.2,1.6c2.9,0,5.2-0.7,5.2-1.6c0,0,0-2.9,0-2.9 C27.3,2.5,25,3.2,22.1,3.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M26.8,2.3v1.7c0,0.9-2.3,1.6-5.2,1.6c-2,0-3.8-0.4-4.6-0.9C17.3,5.4,19.5,6,22.1,6c2.9,0,5.2-0.7,5.2-1.6 c0,0,0-2.9,0-2.9C27.3,1.8,27.1,2.1,26.8,2.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 18.5,
    cy: 4,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 20.2,
    cy: 4.4,
    r: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 22.1,
    cy: 1.6,
    rx: 5.2,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M26.7,0.9c0,0.1,0,0.1,0,0.2c0,0.9-2.3,1.6-5.2,1.6c-2,0-3.8-0.4-4.6-0.9c0.3,0.8,2.5,1.4,5.1,1.4 c2.9,0,5.2-0.7,5.2-1.6C27.3,1.3,27.1,1.1,26.7,0.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendDevelopment);
export default __webpack_public_path__ + "static/media/backend-development.3d9f880723aaf5a08cb078924c7ab66f.svg";
export { ForwardRef as ReactComponent };